import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="header">
      <div className="container">
      <Link to="/">
          <img src="/img/contarte.jpg" alt="Contarte Logo" className="logo-image" />
        </Link>
        <nav className="nav">
        <Link to="/">Home</Link>
          <Link to="/eventos">Eventos</Link>
          <Link to="/cultura">Cultura en la casa</Link>
          <Link to="/recomendaciones">Recomendaciones</Link>
          <Link to="/contacto">Contacto</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;